module.exports = __webpack_public_path__ + "img/p1.cc918fba.png";